

export const getTreeSelect = list => {
    return list;

}


export const flat = (items, c = 0) => {

    let space = String.fromCharCode(160).repeat(c);
    let final = [];
    items.forEach(item => {
          item.name = space + item.name;
          final.push(item);
        if (item.children && typeof item.children !== 'undefined') {
            final = final.concat(flat(item.children, c += 1));
            c -= 1;
        }
    })
     return final;
}


export const getChildId = (data, id) =>  {
    for(var i = 0; i < data.length; i++){
        var el = data[i];
        if(el.id == id) {
            return true;
        }
        if(!!el.children) {
            return getChildId(el.children, id);
        }
    }
}


export const getParentId = (data, id)  => {
    const len = data.length;
    for(var i = 0; i < len; i++){
        var el = data[i];
        var pid = el.id;
        var res = false;
        if(!!el.children) {
            res = getChildId(el.children, id);
        }
        if(res) {
            return pid;
        }
    }
}



export const clearDataRequest = data => {
    for(let key in data) {
        let item = data[key];
        if(!Array.isArray(item)) {
            if(!item) {
                delete data[key];
            }
        }

    }
    return data;
}


export const deepClone = obj =>  {
    if (Array.isArray(obj)) {
        return obj.map(deepClone)
    } else if (obj && typeof obj === 'object') {
        var cloned = {}
        var keys = Object.keys(obj)
        for (var i = 0, l = keys.length; i < l; i++) {
            var key = keys[i]
            cloned[key] = deepClone(obj[key])
        }
        return cloned
    } else {
        return obj
    }
}



let  foverlay = null;

export  const createOverlay  = () => {

    if(document.getElementById('foverlay')  == null) {
        foverlay = $('<div id="foverlay" style="position:fixed;top:0; left:0;width:100%;height:100%;background: radial-gradient(rgba(0, 0, 0, 0.55),black); z-index: 10000"</div>');
        foverlay.append($('<img>', {
            src: "/img/spin.svg",
            style: "position: absolute;left: 50%;top:50%;transform: translateX(-50%);"
        }));
        foverlay.appendTo('body');
    }
}

export const removeOverlay = () =>  setTimeout(() => $('#foverlay').each(function(){$(this).remove()}), 500);



export const loadState = () => {
    try {
        const serializedState = localStorate.getItem('state')
        if(serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    }catch(err){
        return undefined;
    }
}

export const saveState = state => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem(state);
    }catch(err) {
        //
    }
}


// WEBPACK FOOTER //
// ./vue/plugins/utils.js